import { Callout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../connection-manager-next/message-definitions";

export const CombinedStatusBanner = ({ blocking }: { blocking: boolean }) => {
  const intl = useIntl();

  return (
    <Callout
      variant={blocking ? "critical" : "info"}
      description={intl.formatMessage(blocking ? MESSAGES.combinedBannerBlocking : MESSAGES.combinedBannerNonBlocking)}
    />
  );
};
